export enum IncentiveMileageBasis {
  Total = 0,
  LeastDay = 1,
  LeastWeekendDay = 2,
  OffDays = 3,
  Off2Days = 4,
  Least2WeekendDay = 5,
  Least2Day = 6,
  Last2Days = 7,
  LastDay = 8
}

export const IncentiveMileageBasisMapping: Record<IncentiveMileageBasis, string> = {
  [IncentiveMileageBasis.Total]: 'Total',
  [IncentiveMileageBasis.LeastDay]: 'Day with Least Miles',
  [IncentiveMileageBasis.LeastWeekendDay]: 'Weekend with Least Miles',
  [IncentiveMileageBasis.OffDays]: 'Off Day with Least Miles',
  [IncentiveMileageBasis.Off2Days]: 'Off 2 Days with Least Miles',
  [IncentiveMileageBasis.Least2WeekendDay]: 'Weekend (2) with Least Miles',
  [IncentiveMileageBasis.Least2Day]: 'Days (2) with Least Miles',
  [IncentiveMileageBasis.Last2Days]: 'Last 2 Days',
  [IncentiveMileageBasis.LastDay]: 'Last Day'
};
